<template>
  <div
    v-loading.fullscreen.lock="businessLoading"
    :element-loading-text="$store.state.loaderText"
    element-loading-background="rgba(255, 255, 255, 1)"
    id="app"
  >
    <vue-headful
      title="Home"
    />
    <ec-business-mobile-menu
      :menu="items"
      :toggle="toggle"
      @toggle="toggleNavbar"
    />
    <ec-business-header
      v-if="surrounding"
      :surrounding="surrounding"
      @toggle="toggleNavbar"
    >
      <div
        slot="menu"
        class="buheader-bottom"
      >
        <ec-business-header-menu
          :menu="items"
          :surrounding="surrounding"
        />
      </div>
    </ec-business-header>

    <router-view :blocks="items" :surrounding="surrounding" />

    <ec-business-footer
      v-if="surrounding"
      :surrounding="surrounding"
      :privacy="privacy"
    />

    <ec-business-dialog
      v-if="dialog.visible"
      :visibility.sync="dialog.visible"
      class="business-dialog"
    />

    <SideMenu/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Utilities from '@/mixins/Utilities'
import Service from '@/services/ApiService'
import BusinessService from '@/services/BusinessService'
// components
import SideMenu from '@/components/General/Template/Navigation/SideMenu'
import ecBusinessDialog from '@/components/Business/components/Dialog'
import ecBusinessFooter from '@/components/Business/components/General/Template/Footer'
import ecBusinessHeader from '@/components/Business/components/General/Template/Header'
import ecBusinessHeaderMenu from '@/components/Business/components/General/Template/Navigation/HeaderMenu'
import ecBusinessMobileMenu from '@/components/Business/components/General/Template/Navigation/MobileMenu'

export default {
  name: 'ec-business-app',
  components: {
    ecBusinessDialog,
    ecBusinessFooter,
    ecBusinessHeader,
    ecBusinessHeaderMenu,
    ecBusinessMobileMenu,
    SideMenu
  },
  mixins: [Utilities],
  data () {
    return {
      items: [],
      privacy: null,
      toggle: false,
      surrounding: null
    }
  },
  computed: {
    ...mapState([
      'dialog',
      'businessLoading'
    ]),
    id () {
      const slugs = this.$route.params.slug.split('-')
      return slugs[slugs.length - 1]
    },
    hasSocial () {
      return this.surrounding.facebook || this.surrounding.instagram || this.surrounding.twitter
    },
    year () {
      return new Date().getFullYear()
    }
  },
  methods: {
    toggleNavbar () {
      this.toggle = !this.toggle
    },
    reload () {
      this.$router.push()
      this.$store.commit('setBusinessLoading', false)
    }
  },
  created () {
    this.$store.commit('setBusinessLoading', true)

    const url = 'community/surrounding/' + this.id
    Service.get(url).then(surrounding => {
      this.surrounding = surrounding
      const buttonUrl = 'community/surrounding/' + surrounding.id + '/button/personal'
      Service.get(buttonUrl).then(data => {
        const buttons = data.data[0].items.data
        let bService = new BusinessService(buttons)
        let items = bService.getItems()
        let privacy = bService.getPrivacyStatement()

        if (items.length) {
          // Place recras 'Natuurpoort van loon'
          if (this.id === 1053) {
            items.unshift({
              text: 'Boeken',
              type: 'enjoj\\dates\\Recras',
              graphic: {
                data: {
                  graphic: 'https://enjoj-cdn-fra.s3.eu-central-1.amazonaws.com/Core/1564143650079r4TCHAxHLaPP4'
                }
              }
            })
            items.splice(1, 0, items.splice(0, 1)[0])
          }
          this.items = items
          this.privacy = privacy
          this.$store.commit('setBusinessLoading', false)
        } else {
          this.reload()
        }
      }, () => {
        this.reload()
      })
    }, () => {
      this.reload()
    })
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/business.scss';
</style>
